export const NA = { label: 'N/A', value: 'NOT_AVAILABLE' };
export const FULL_TIME = { label: '24h', value: 'FULL_TIME' };
export const LIMITED_HOURS = { label: 'Limited hours', value: 'LIMITED_HOUR' };
export const LIMITED_HOURS_MOBILE = { label: 'Limited', value: 'LIMITED_HOUR' };
export const MAX_TOTAL_CAPACITY = 198;

export const DEFAULT_FROM = '00:00';
export const DEFAULT_TO = '23:50';

export const ROOMS_SERVICES_OPTIONS = [NA, FULL_TIME, LIMITED_HOURS];
export const ROOMS_SERVICES_OPTIONS_MOBILE = [
  NA,
  FULL_TIME,
  LIMITED_HOURS_MOBILE,
];
